export default class Calculator {
  constructor () {
    this.getParam()
    this.bindEvent()
  }


  getParam() {
    this.calcItem = document.querySelectorAll(`[data-module='calc-control']`)
    this.calcItemArray = Array.prototype.slice.call(this.calcItem)
  }

  bindEvent() {
    this.calc()
  }


  calc() {
    Array.prototype.forEach.call(this.calcItemArray,(Item) => {
      const
        minus = Item.getElementsByClassName('minus')[0],
        plus = Item.getElementsByClassName('plus')[0],
        number = Item.getElementsByClassName('number')[0]
      let
        numberEntity = number.textContent
      
      minus.addEventListener('click', ()=> {
        number.innerHTML = --numberEntity

        if(numberEntity === 1) {
          minus.classList.add('is-stop')
        }
      })
      plus.addEventListener('click', ()=> {
        number.innerHTML = ++numberEntity

        if(numberEntity > 1) {
          minus.classList.remove('is-stop')
        }
      })
    })
  }

}